import React from "react";

export const NoData = () => {
	return (
		<div>
			<h5>No Data Available</h5>
			<div
				className="text-center"
				style={{ fontSize: "5rem", color: "#f1f1f1", margin: "auto" }}
			>
				<i className="fas fa-inbox"></i>
			</div>
		</div>
	);
};
